<template>
  <div class="container text-left">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
          <div class="card-body">
            <h5 class="card-title text-center">EV Monitoring</h5>
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }" tag="div">
              <form class="form-signin" id="loginFrm" name="loginFrm"
                    @submit.prevent="handleSubmit(onSubmit)" @reset="resetForm">
                <ValidationProvider v-slot="{ errors }" tag="div" class="form-label-group"
                                    name="아이디"
                                    rules="required|id">
                  <input type="text" id="inputId" class="form-control" placeholder="아이디를 입력해주세요."
                         v-model="form.id" autofocus autocomplete="off">
                  <label for="inputId">아이디</label>
                  <span class="text text-danger pt-2 pl-2 d-block" v-if="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider v-slot="{ errors }" tag="div" class="form-label-group"
                                    name="비밀번호"
                                    rules="required|min:3">
                  <input type="password" id="inputPassword" class="form-control" placeholder="비밀번호를 입력해주세요."
                         v-model="form.pw" autofocus autocomplete="off">
                  <label for="inputPassword">비밀번호</label>
                  <span class="text text-danger pt-2 pl-2 d-block" v-if="errors[0]">{{ errors[0] }}</span>
                </ValidationProvider>

                <div class="alert alert-danger" v-if="loginError">
                  로그인에 실패 하였습니다.
                </div>

                <button class="btn btn-lg btn-primary btn-block text-uppercase" type="submit">로그인</button>

              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ax from '@/api/auth'

export default {
  name: 'Login',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      form_: { type: 9, id: 'guest', pw: 'test' }, // admin / test
      form: {},
      loginError: false
    }
  },
  created () {
    if (this.$store.state.user !== null) {
      this.$router.push('/dashboard')
    }
    this.form = _.cloneDeep(this.form_)
  },
  methods: {
    onSubmit () {
      ax.getToken(this.form, (flag, msg) => {
        if (flag) {
          this.$store.state.user = this.form.id;
          this.$router.push('/dashboard')
        } else {
          this.$notify({
            group: 'alert',
            type: 'warn',
            title: '경고',
            text: msg
          })
        }
      })
    },
    resetForm () {
      this.form = _.cloneDeep(this.form_)
    }
  }
}
</script>

<style lang="scss" scoped>
$input-padding-x: 1.5rem;
$input-padding-y: .75rem;

body {
  background: #007bff;
  background: linear-gradient(to right, #0062E6, #33AEFF);
}

.card-signin {
  border: 0;
  border-radius: 0.1rem;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
}

.card-signin .card-title {
  margin-bottom: 2rem;
  font-weight: 300;
  font-size: 1.5rem;
}

.card-signin .card-body {
  padding: 2rem;
}

.form-signin {
  width: 100%;
}

.form-signin .btn {
  border-radius: 5rem;
  letter-spacing: .1rem;
  padding: 1rem;
  transition: all 0.2s;
}

.form-label-group {
  position: relative;
  margin-bottom: 1rem;
}

.form-label-group input {
  height: auto;
  border-radius: 2rem;
}

.form-label-group > input,
.form-label-group > label {
  padding: $input-padding-y $input-padding-x;
}

.form-label-group > label {
  position: absolute;
  top: 3px;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0;
  line-height: 1.5;
  color: #495057;
  border: 1px solid transparent;
  border-radius: .25rem;
  transition: all .1s ease-in-out;
}

.form-label-group input::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group input:-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-moz-placeholder {
  color: transparent;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: ($input-padding-y + $input-padding-y * (2 / 3));
  padding-bottom: ($input-padding-y / 3);
}

.form-label-group input:not(:placeholder-shown) ~ label {
  padding-top: $input-padding-y / 3;
  padding-bottom: $input-padding-y / 3;
  font-size: 12px;
  color: #777;
}
</style>
